import { Asset } from '@travelity/api/services';

export interface CreateAssetModalProps {
    handleCancel: () => void;
    handleConfirm: (v: Asset) => void;
    open: boolean;
}

export type CreateAsset = Omit<Asset, 'id'> & {
    vehicleGroup: VehicleGroup;
};

export enum VehicleGroup {
    AUTOMOBILE = 'Land Vehicle',
    BOAT = 'Watercraft',
    AIRCRAFT = 'Aircraft',
}
